import React from "react";
import TurnrDropdownSelect from "~/components/input/TurnrDropdownSelect.jsx";
import { InputGridWrapper, SettingsContainerWrapper } from "./settingComponents";
import { getExchangePropertyPickerOptions, getProductImageObjectFitOptions } from "~/cores/appCore";

export default function OtherSettings(props) {
    const { iFrameData, appProps } = props;

    const productImageObjectFitOptions = getProductImageObjectFitOptions(appProps);
    const exchangePropertyPickerOptions = getExchangePropertyPickerOptions(appProps);

    return (
        <SettingsContainerWrapper>
            <InputGridWrapper>
                <TurnrDropdownSelect
                    size={"small"}
                    tooltip={
                        <div>
                            This only affects the big Exchange To image in the return portal.
                            <br />
                            <br />
                            If you only (or mainly) have a certain aspect ratio of product images on your site, then it's advisable to set the same aspect ratio here so when customer select Exchange
                            they get to see the complete image
                            <br />
                            <br />
                        </div>
                    }
                    label="Exchange product image aspect ratio, x:y"
                    allowCreateOption={true}
                    allowCreateOptionLabel={"Custom ratio"}
                    fullWidth={true}
                    {...props.productImageAspectRatio}
                    onChange={props.setProductImageAspectRatio}
                    options={["1:1", "3:4", "4:5", "9:16", "4:3", "5:4", "16:9"]}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrDropdownSelect
                    size={"small"}
                    tooltip={
                        <div>
                            This setting affects all places that shows a product image in the return portal.
                            <br />
                            <br />
                            This will only apply when the image aspect ratio does not match the product image that is being shown
                            <br />
                            <br />
                            Cover: The image keeps its aspect ratio and fills the given dimension. The image will be clipped to fit
                            <br />
                            <br />
                            Contain: the image keeps its aspect ratio, but is resized to fit within the given dimension
                        </div>
                    }
                    label="Product image fitting"
                    fullWidth={true}
                    {...props.productImageObjectFit}
                    onChange={props.setProductImageObjectFit}
                    options={productImageObjectFitOptions}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrDropdownSelect
                    size={"small"}
                    tooltip={<div>We have a few options for how the exchange property picker should behave when the customer is exchanging a product</div>}
                    label="Exchange property picker"
                    fullWidth={true}
                    {...props.exchangePropertyPicker}
                    onChange={props.setExchangePropertyPicker}
                    options={exchangePropertyPickerOptions}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrDropdownSelect
                    size={"small"}
                    tooltip="A little bit of fancy flare to the success. Navigate to the end of the preview, to the success page, to see what this does"
                    label="Success confetti"
                    fullWidth={true}
                    {...props.successConfetti}
                    onChange={props.setSuccessConfetti}
                    options={iFrameData?.successConfettiOptions || []}
                />
            </InputGridWrapper>
        </SettingsContainerWrapper>
    );
}
